module.exports = __webpack_public_path__ + "img/finance-illustration-03.98802b4a.png";